import { useState, useEffect } from 'react';
import { Shield, X } from 'lucide-react';

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('jf-nexus-cookie-consent');
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 2000);
      return () => clearTimeout(timer);
    }
  }, []);

  const accept = (type) => {
    localStorage.setItem('jf-nexus-cookie-consent', JSON.stringify({ type, date: new Date().toISOString() }));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div data-testid="cookie-consent-banner" className="fixed bottom-6 left-4 right-4 sm:left-6 sm:right-6 z-50 mx-auto max-w-2xl">
      <div className="bg-white/70 backdrop-blur-2xl border border-white/80 shadow-[0_8px_32px_rgba(0,0,0,0.08)] rounded-2xl p-5 sm:p-6">
        <div className="flex items-start gap-4">
          <div className="hidden sm:flex p-2.5 rounded-xl bg-gradient-to-br from-indigo-500/10 to-pink-500/10 flex-shrink-0">
            <Shield size={18} className="text-purple-600" />
          </div>
          <div className="flex-1 min-w-0">
            <h4 className="text-sm font-semibold text-slate-900 font-['Outfit']">Cookie-Einstellungen</h4>
            <p className="mt-1 text-xs text-slate-500 leading-relaxed">
              Wir verwenden Cookies, um Ihnen das beste Erlebnis zu bieten. Notwendige Cookies sind für die Funktion erforderlich. Analyse-Cookies helfen uns, die Website zu verbessern.
            </p>
            <div className="mt-4 flex flex-wrap gap-2.5">
              <button
                onClick={() => accept('all')}
                className="text-xs font-medium px-5 py-2.5 rounded-full bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-500 text-white hover:shadow-lg hover:shadow-pink-500/20 transition-all"
                data-testid="cookie-accept-all"
              >
                Alle akzeptieren
              </button>
              <button
                onClick={() => accept('necessary')}
                className="text-xs font-medium px-5 py-2.5 rounded-full bg-white border border-slate-200 text-slate-700 hover:bg-slate-50 transition-all"
                data-testid="cookie-accept-necessary"
              >
                Nur notwendige
              </button>
            </div>
          </div>
          <button onClick={() => setVisible(false)} className="text-slate-400 hover:text-slate-600 flex-shrink-0" data-testid="cookie-close">
            <X size={16} />
          </button>
        </div>
      </div>
    </div>
  );
}
